import LocalizationService from "../../../services/localizationService";
import { ScreenBase } from "@frui.ts/screens/dist";
import { interfaces } from "inversify";
import { action, observable } from "mobx";

export default class GDPRViewModel extends ScreenBase {
  @observable gdprVisible = false;

  constructor(public message: string, public localizationService: LocalizationService) {
    super();
  }

  @action.bound
  toggleGdpr = (show: boolean) => () => {
    this.gdprVisible = show;
  };

  static Factory({ container }: interfaces.Context) {
    return (message: string) => new GDPRViewModel(message, container.get(LocalizationService));
  }
}
